import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { finectAPI } from '@finect/front-utils/finectAPI';

var Applications = function () {
  function Applications(appID) {
    var _this = this;

    _classCallCheck(this, Applications);

    _defineProperty(this, "appID", null);

    _defineProperty(this, "sessionID", null);

    _defineProperty(this, "status", 'uncompleted');

    _defineProperty(this, "fields", []);

    _defineProperty(this, "latest", null);

    _defineProperty(this, "created", null);

    _defineProperty(this, "updated", null);

    _defineProperty(this, "toObject", function (fields) {
      var object = {};

      for (var i = 0; i < fields.length; i++) {
        var field = _this.getField(fields[i]);

        if (field) {
          object[fields[i]] = field.value;
        }
      }

      return object;
    });

    _defineProperty(this, "getField", function (fieldName) {
      return _this.fields.find(function (field) {
        return field.field === fieldName;
      });
    });

    _defineProperty(this, "getSessionID", function () {
      return _this.sessionID;
    });

    _defineProperty(this, "setStatus", function (status) {
      _this.status = status;
      return _this;
    });

    _defineProperty(this, "setFieldValue", function (fieldName, fieldValue, defaultValue) {
      var field = _this.getField(fieldName);

      if (field) {
        for (var i = 0; i < _this.fields.length; i++) {
          if (_this.fields[i].field === fieldName) {
            _this.latest = fieldName;
            _this.fields[i].value = fieldValue;
            _this.fields[i].clean = false;
          }
        }
      } else {
        _this.latest = fieldName;

        _this.fields.push({
          field: fieldName,
          value: fieldValue,
          default: typeof defaultValue !== 'undefined' ? defaultValue : null,
          clean: false
        });
      }

      return _this;
    });

    _defineProperty(this, "updateFieldValue", function (fieldName) {
      if (!_this.sessionID) return false;
      finectAPI({
        version: 'v4',
        path: "applications/".concat(_this.appID, "/sessions/").concat(_this.sessionID),
        method: 'PUT',
        referrerPolicy: 'no-referrer-when-downgrade',
        credentials: 'include',
        body: {
          status: 'uncompleted',
          items: _this.getField(fieldName)
        }
      });
    });

    _defineProperty(this, "setFields", function (fields) {
      for (var i = 0; i < fields.length; i++) {
        _this.setFieldValue(fields[i].field, fields[i].value, typeof fields[i].default !== 'undefined' ? fields[i].default : null);
      }

      return _this;
    });

    _defineProperty(this, "reset", function () {
      _this.sessionID = null;
      _this.fields = [];
      _this.status = null;
      _this.created = null;
      _this.updated = null;
      return _this;
    });

    _defineProperty(this, "emptyFields", function () {
      _this.fields = [];
      return _this;
    });

    _defineProperty(this, "removeField", function (fieldName) {
      _this.fields = _this.fields.filter(function (field) {
        return field.field !== fieldName;
      });
      return _this;
    });

    _defineProperty(this, "getBody", function (latest) {
      return {
        status: _this.status,
        items: latest ? _this.fields.filter(function (field) {
          return field.field === _this.latest;
        }).map(function (field) {
          return field;
        }) : _this.fields.filter(function (field) {
          return field.value !== null && field.clean === false;
        }).map(function (field) {
          console.log(field.field, field.type, field.value);
          return {
            field: field.field,
            value: field.type == 'number' ? Number(field.value) : field.value,
            default: field.default
          };
        })
      };
    });

    _defineProperty(this, "send", function () {
      if (!_this.sessionID) {
        _this.post();
      } else {
        _this.put(false);
      }
    });

    _defineProperty(this, "sendLatest", function () {
      if (!_this.sessionID) {
        _this.post();
      } else {
        _this.put(true);
      }
    });

    _defineProperty(this, "get", function () {
      var tracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      var _onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      var url = tracking ? "applications/".concat(_this.appID, "/sessions/last?tracking=").concat(tracking) : "applications/".concat(_this.appID, "/sessions/last");
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            _this.sessionID = response.data.id;
            _this.fields = response.data.items;
            _this.status = response.data.status;
            _this.created = response.data.created || null;
            _this.updated = response.data.updated || null;
          }

          _onSuccess(response, _this);
        },
        onError: function onError(response) {
          _onError(response);
        }
      });
    });

    _defineProperty(this, "getSettings", function () {
      var _onSuccess2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var _onError2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      var url = "applications/".concat(_this.appID, "/settings");
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            console.log(response.data.fields);
            _this.fields = response.data.fields.map(function (field) {
              return {
                field: field.field,
                type: field.type,
                format: field.format,
                application: field.lastValue ? field.lastValue.application.id : null,
                value: field.lastValue ? field.lastValue.value : null,
                default: field.lastValue ? field.lastValue.value : null,
                clean: true
              };
            });

            _onSuccess2(response);
          }
        },
        onError: function onError(response) {
          _onError2(response);
        }
      });
    });

    _defineProperty(this, "findSession", function () {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var _onSuccess3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      var _onError3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      _this.reset();

      var url = "applications/".concat(_this.appID, "/sessions");
      var session = null;
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          response.data.forEach(function (app) {
            var found = app.items.find(function (item) {
              return app.status === 'completed' && item.field === field && item.value === value;
            });

            if (found) {
              session = app;
              _this.sessionID = app.id;
              _this.fields = app.items;
              _this.status = app.status;
              _this.created = app.created || null;
              _this.updated = app.updated || null;
            }
          });

          _onSuccess3(session);
        },
        onError: function onError(response) {
          _onError3(response);
        }
      });
    });

    _defineProperty(this, "post", function () {
      finectAPI({
        version: 'v4',
        path: "applications/".concat(_this.appID, "/sessions"),
        method: 'POST',
        referrerPolicy: 'no-referrer-when-downgrade',
        body: _this.getBody(),
        credentials: 'include',
        onSuccess: function onSuccess(data) {
          if (data.code === 201) {
            _this.sessionID = data.data.id;
          }
        }
      });
    });

    _defineProperty(this, "put", function (latest) {
      finectAPI({
        version: 'v4',
        path: "applications/".concat(_this.appID, "/sessions/").concat(_this.sessionID),
        method: 'PUT',
        referrerPolicy: 'no-referrer-when-downgrade',
        credentials: 'include',
        body: _this.getBody(latest)
      });
    });

    this.appID = appID;
    this.fields = [];
    this.status = 'uncompleted';
    this.latest = null;
    this.created = null;
    this.updated = null;
  }

  _createClass(Applications, null, [{
    key: "load",
    value: function load(appID) {
      var _this2 = this;

      return finectAPI({
        version: 'v4',
        path: "applications/".concat(appID, "/sessions/last"),
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            var instance = new _this2(appID);
            instance.sessionID = response.data.id;
            instance.fields = response.data.items;
            instance.status = response.data.status;
            instance.created = response.data.created || null;
            instance.updated = response.data.updated || null;
            return instance;
          }
        },
        onError: function onError(response) {
          return new _this2(appID);
        }
      });
    }
  }, {
    key: "loadFromAPIResponse",
    value: function loadFromAPIResponse(response) {
      var instance = new this(response.application.id);
      instance.sessionID = response.application.id;
      instance.fields = response.items;
      instance.status = response.status;
      instance.created = response.created || null;
      instance.updated = response.updated || null;
      return instance;
    }
  }]);

  return Applications;
}();

export { Applications };